let utils = require('../../../actions/utils');
let content = require('../../../actions/layout/content');
let account = require('../../../actions/account');
let orders = require('../../../actions/account/orders');
let ordersList = require('../../../actions/account/orders-list');
let computedOrdersList = require('../../../actions/computed/account/orders-list');
let userGroup = require('../../groups/user');
let layoutGroup = require('../../groups/layout');
let analytics = require('../../../actions/analytics');
let { getManagersList, getUsersList } = require('../../groups/account');
let seo = require('../../../actions/seo');
let user = require('../../../actions/user');
let utilsSignals = require('../../../signals/utils');

let setDefaults = [
    utils.setPopupVisibility('statusFilter', ['account', 'popups', 'statusFilter', 'isOpen']),
    utils.setPopupVisibility('userSelect', ['account', 'popups', 'userSelect', 'isOpen']),
    utils.setPopupVisibility('managerSelect', ['account', 'popups', 'managerSelect', 'isOpen']),
    utils.setPopupVisibility('createOrder', ['account', 'popups', 'createOrder', 'isOpen']),
    ordersList.setPagingDefaultsIfNeeded,
    utils.set(['account', 'orders', 'managers'], []),
    ordersList.setShouldRestoreFiltersFromLocalStorage,
    ordersList.setStateFormUrlManager,
    ordersList.setStatusFilterData,
    ordersList.setTypeFilterData,
    orders.initOrderCreatorSelect
];

let setComputedForManager = [
    computedOrdersList.setStatusSelect,
    computedOrdersList.setRadioFilter,
    computedOrdersList.computeIsRadioFilterActive
];

module.exports = [
    analytics.parseUtmFromQuery,
    content.setIsLoading(true),
    ...userGroup.checkAuthCookie([
        ...userGroup.getUser
    ]),
    [
        user.isUnauthorized,
        {
            yes: [
                utils.setArgToCookie('orderId', 10),
                ...utilsSignals.redirectLogin
            ],
            no: [
                ...userGroup.access('manager', [
                    utils.set('layout', 'main'),
                    utils.setFromArgsToState('subPage', 'page.sub'),
                    ...layoutGroup.setMainLayoutBlocks,
                    seo.setDashboardMeta('Панель менеджера - Библиотека данных', 'Панель менеджера'),
                    content.setComponentsByLink,
                    ...setDefaults,
                    account.setComputedFields,
                    orders.setComputedFields,
                    ordersList.setComputedFields,
                    ...setComputedForManager,
                    ...getManagersList,
                    ...getUsersList,
                    orders.initOrderType,
                    analytics.pageview,
                    content.setIsLoading(false)
                ])
            ]
        }
    ]
];



// WEBPACK FOOTER //
// ./signals/pages/manager/orders.js